import { render, staticRenderFns } from "./DeletePhasesButton.vue?vue&type=template&id=43bd6620"
import script from "./DeletePhasesButton.vue?vue&type=script&lang=js"
export * from "./DeletePhasesButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports